export default {
  add_products: '+ Adicionar produtos',
};
